import { createTypedAsyncThunk, withOrgId } from '../utils/actions';
import * as API from '@/data/api/files';
import { RequestParams, TFileItem, TFilePayload, TFileSubfoldersItem } from '@/data/types';
import { State } from '../state/state';
import { ProgressCallback } from '@/data/api/utils/network';

export const getAllFilesAsync = createTypedAsyncThunk<{ items: TFileItem[] }, RequestParams, { state: State }>(
  'files/getAllFiles',
  async (params, { getState }) => {
    return API.getAllFiles(withOrgId(getState, params));
  },
);

export const getFilePathsAsync = createTypedAsyncThunk<
  { subfolders: TFileSubfoldersItem[] },
  { path: string },
  { state: State }
>('files/getFilePaths', async (params, { getState }) => {
  return API.getAllFiles(withOrgId(getState, params));
});

export const createFileAsync = createTypedAsyncThunk<
  TFileItem,
  { payload: TFilePayload; onProgress?: ProgressCallback },
  { state: State }
>('files/createFile', async ({ payload, onProgress }, { getState }) => {
  return API.createFile(withOrgId(getState), payload, onProgress);
});

export const getFileByIdAsync = createTypedAsyncThunk<
  TFileItem,
  { fileId: string; params?: RequestParams },
  { state: State }
>('files/getFileById', async ({ fileId, params = {} }, { getState }) => {
  return API.getFileById(fileId, withOrgId(getState, params));
});

export const updateFileAsync = createTypedAsyncThunk<
  TFileItem,
  { fileId: string; params?: RequestParams; payload: Partial<TFilePayload> },
  { state: State }
>('files/updateFile', async ({ fileId, params = {}, payload }, { getState }) => {
  return API.updateFile(fileId, withOrgId(getState, params), payload);
});

export const deleteFileAsync = createTypedAsyncThunk<
  { success: boolean },
  { fileId: string; params?: RequestParams },
  { state: State }
>('files/deleteFile', async ({ fileId, params = {} }, { getState }) => {
  return API.deleteFile(fileId, withOrgId(getState, params));
});
